export default __webpack_public_path__ + "static/media/sign_disabled.0b226060.svg";